import { User, UserAddress, UserAddressPayload } from '@toggle/toggle';

import { create } from '~/utils/store/createStore';

import { putUserAddress, putUserData } from './service/user-service';

interface UserStore {
  user?: User;
  address?: UserAddress;
  loading: boolean;
  error: boolean;

  updateUser: (user: Partial<User>) => Promise<void>;
  refreshUser: () => Promise<void>;
  updateUserAddress: (address: UserAddressPayload) => Promise<void>;
}

// const syncTimeZone = async (tzName: string, tzOffset: number) => {
//   const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
//   const offset = getOffset();

//   if (tzName !== timezone || tzOffset !== offset) {
//     await putUserTimezone({
//       name: timezone,
//       offset,
//     });
//   }
// };

export const useUser = create<UserStore>((set, get) => {
  return {
    user: undefined,
    address: undefined,
    loading: false,
    error: false,
    refreshUser: async () => {
      // const userData = await getUserData();
      // if (userData.error) {
      //   set({ error: true, loading: false });
      // } else {
      //   set({
      //     user: {
      //       ...(get().user as User),
      //       ...userData.data,
      //     },
      //     loading: false,
      //   });
      // }
    },
    updateUser: async (dataToUpdate: Partial<User>) => {
      const { ...userData } = get().user as User;
      const updated = await putUserData({
        ...userData,
        ...dataToUpdate,
      });

      if (!updated.error) {
        set(state => ({
          user: {
            ...(state.user as User),
            ...updated.data,
          },
        }));
      }
    },

    updateUserAddress: async (address: UserAddressPayload) => {
      const response = await putUserAddress(address);

      if (!response.error) {
        set({ address: response.data });
      }
    },
  };
});
